<template>

<div class="checkbox-wrapper">
    <input 
        type="checkbox" 
        :id="`checkbox-${uuid}`" 
        class="regular-checkbox" 
        v-bind:checked="checked" 
        @change="$emit('change', $event.target.checked)"/>
        
    <label :for="`checkbox-${uuid}`"></label>
</div>

</template>

<script>
let uuid = 0;

export default {
    beforeCreate() {
        this.uuid = uuid.toString();
        uuid += 1;
    },

    model: {
        prop: 'checked',
        event: 'change',
    },

    props: {
        checked: Boolean
    },
}
</script>

<style lang="scss" scoped>
label {
    display: inline;
    cursor: pointer;
}

.checkbox-wrapper {
    display: inline-block;
    line-height: 1em;
    vertical-align: middle;
}

.regular-checkbox {
	display: none;
}

.regular-checkbox + label {
	background-color: white;
	border: 2px solid black;
    
    width: 24px;
    height: 24px;

    padding: 9px;
	display: inline-block;
	position: relative;
}

.regular-checkbox + label:active, .regular-checkbox:checked + label:active {
}

.regular-checkbox:checked + label {
}

.regular-checkbox:checked + label:after {
	content: 'Г'; // правда ж я хитрий чортяка?
    transform: rotate(-140deg);
    
    font-size: 16px;
    line-height: 1em;
    font-weight: 400;
	position: absolute;
	top: 0px;
    left: 5px;
}
</style>

